import { Vehicle } from '@/interfaces/vehicle'

export const mockedData: Vehicle[] = [
  {
    id: 3,
    name: 'P05315',
    type: 'CAR',
  },
]
